export const FURIOUS = 0;
export const ANGRY = .2;
export const NEUTRAL = .4;
export const HAPPY = .6;
export const ECSTATIC = .8;